const initialState = {
  products: [],
  locations: [],
  aisles: [],
  lastFetchedTime: null,
  locationFetchedTime: null,
  aisleFetchedTime: null,
  obStatus: false,
  type: '',
  roles: []
};

const userCreds = (state = initialState, action) => {
  switch (action.type) {

      case "SET_PRODUCTS":
        return {
          ...state,
          products: action.payload.products,
          lastFetchedTime: action.payload.timestamp,
        };
        case "SET_LOCATIONS":
        return {
          ...state,
          locations: action.payload.locations,
          locationFetchedTime: action.payload.timestamp,
        };
        case "SET_AISLE":
          return {
            ...state,
            aisles: action.payload.aisles,
            aisleFetchedTime: action.payload.timestamp,
          };
      case 'SET_OB_STATUS':
        return {
          ...state,
          obStatus: action.payload,
        };
        case "SET_USER_TYPE":
      return {
        ...state,
        type: action.payload,
      };
      case "SET_USER_ROLES":
        return {
          ...state,
          roles: action.payload,
        };
    case 'RESET_STATE':
        return initialState;
      
    default:
      return state;
  }
};

export default userCreds;
